import { AxiosError } from "axios";
import { useMemo } from "react";
import useSWR from "swr";

import { UserDetailsModel } from "@user/models/UserByEmailResponse";

import { userEndpoints } from "@api/Endpoints";
import { fetcher } from "@utils/swr-utils";

export function useGetUserByEmail(email: string | null) {
  let url: null | string = null;

  if (email) {
    const params = new URLSearchParams();
    params.append("email", email);
    url = userEndpoints.getUserBy() + `?${params.toString()}`;
  }

  const { data, error, isLoading } = useSWR<UserDetailsModel, AxiosError>(
    url,
    fetcher,
    { revalidateOnFocus: false }
  );

  return useMemo(() => ({ data, isLoading, error }), [data, isLoading, error]);
}
